export { default } from './lib/icon-alert.vue';